import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const ArrowBackSvg = () => (
  <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.9999 3.99997H4.41394L6.70694 1.70697L5.29294 0.292969L0.585938 4.99997L5.29294 9.70597L6.70694 8.29297L4.41394 5.99997H19.9999V3.99997Z" fill="currentColor" />
  </svg>
);

const ArrowBackMenu = (props: IIconProps) => <Icon component={ArrowBackSvg} {...props} />;

export default ArrowBackMenu;
